/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { monitoringCommonEnumsRetrieve } from '../fn/monitoring-enums/monitoring-common-enums-retrieve';
import { MonitoringCommonEnumsRetrieve$Params } from '../fn/monitoring-enums/monitoring-common-enums-retrieve';
import { BackendMonitoringEnumChoicesDto } from '../models/backend-monitoring-enum-choices-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiMonitoringEnumsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `monitoringCommonEnumsRetrieve()` */
  static readonly MonitoringCommonEnumsRetrievePath = '/api/monitoring/common/enums/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringCommonEnumsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringCommonEnumsRetrieve$Response(
    params?: MonitoringCommonEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMonitoringEnumChoicesDto>> {
    return monitoringCommonEnumsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringCommonEnumsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringCommonEnumsRetrieve(
    params?: MonitoringCommonEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendMonitoringEnumChoicesDto> {
    return this.monitoringCommonEnumsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMonitoringEnumChoicesDto>): BackendMonitoringEnumChoicesDto => r.body),
    );
  }
}
